import { Material, MeshPhysicalMaterial, MeshStandardMaterial, Color, FrontSide } from "three";
import { BubbleMaterial } from "./BubbleMaterial";
import { GlassCellShaderMaterial } from "./GlassCellShaderMaterial";
import { TubeMaterial } from "./TubeMaterial";
import { SphereFresnelMaterial } from "./SphereFresnelMaterial";

import { extend } from "@react-three/fiber";
import { MeshTransmissionMaterial } from "@react-three/drei";

import { DNAMaterial } from "./DNAMaterial";
import { WaterMaterial } from "./Tempelhof_WasserMaterial";

import { SoapTransparentMaterial } from "./SoapTransparent";
import { ZellwandMaterial } from "./ZellwandMaterial";
import { HumanoidMaterial } from "./HumanoidMaterial2";
import { FoamMaterial } from "./FoamMaterial.marlin";
import { UnderwaterMaterial } from "./Underwater.marlin";
import { MarlinBodyMaterial } from "./MarlinBody.marlin";

// Extend das Material, damit es in Three.js genutzt werden kann
extend({ MeshTransmissionMaterial });

export const MaterialLibrary: {
	[key: string]: (args?: any) => Promise<Material>;
} = {
	GlasCellMaterial: GlassCellShaderMaterial,

	//Charité
	cell1_original: ZellwandMaterial, // GlassCellShaderMaterial,
	// CellMaterial: ZellwandMaterial, // GlassCellShaderMaterial,

	// CellMaterial: ZellwandMaterial,

	// FU Object
	// bismuth: BubbleMaterial,
	// FU
	//"sphere glass_n": SphereFresnelMaterial,
	"sphere glass_n": SphereFresnelMaterial, //SoapBubbleMaterial,
	Eco_Lines: async () => {
		const mat = new MeshStandardMaterial({ color: 0xeeeeee, transparent: true, depthTest: false, depthWrite: false }); // await SimpleGlassMaterial(0x7356e7);
		return mat;
	},
	Eco_Nodes: async () => {
		const mat = new MeshStandardMaterial({ color: 0x835eb8, transparent: true, depthTest: false, depthWrite: false }); // await SimpleGlassMaterial(0x7356e7);
		return mat;
	},

	// Octapatch
	Dispersion_1: async () => await TubeMaterial([0.8549, 0.2, 0.843], false),
	Dispersion_2: async () => await TubeMaterial([0.3725, 0.9411, 0.9254], false),
	Dispersion_3: async () => await TubeMaterial([0.3725, 0.9411, 0.9254], true),

	// Tempelhof
	DNA: async () => await DNAMaterial(0x37e8cc),
	DNA_Pink: async () => await DNAMaterial(0xe77fa8),
	Water: async () => await WaterMaterial(0x6dc0e7),

	underwater: UnderwaterMaterial,

	BubbleMaterial: BubbleMaterial,
	Tube: TubeMaterial,

	// Humanoid
	soap_trans: SoapTransparentMaterial, // SoapTransparentMaterial,
	fake_dispersion: HumanoidMaterial,

	// Marlin
	// blackmarlin_body: MarlinBodyMaterial,
	// "blackmarlin_fins.001": MarlinBodyMaterial,
	Foam: FoamMaterial, // async () => await new MeshPhysicalMaterial({ transparent: true, opacity: 0.8, metalness: 1 }), // WasserMaterial,
	// maskBox: MaskMaterial,

	Coffee_Glas: async () => {
		const mat = new MeshPhysicalMaterial({
			metalness: 0,
			roughness: 0.02,
			envMapIntensity: 1.3,
			transmission: 1,
			ior: 1.5,
			side: FrontSide,
			thickness: 0.1,
			attenuationColor: new Color(0xffffff),
			attenuationDistance: 0.8,
			clearcoat: 1,
			clearcoatRoughness: 0.03,
		});
		return mat;
	},
	Kaffee: async () => {
		const mat = new MeshPhysicalMaterial({
			color: new Color(0x31190c), // kräftiges Braun = 3c1f0f
			// transmission: 1,
			roughness: 0.05,
			// transparent: true,
			// opacity: 0.99,
			metalness: 0,
			ior: 1.33,
			thickness: 0.1,
			attenuationColor: new Color(0x221109),
			attenuationDistance: 0.2,
		});
		return mat;
	},
};
